// Fonts
import InterBlackTtf from "./assets/fonts/Inter-Black.ttf";
import InterBoldTtf from "./assets/fonts/Inter-Bold.ttf";
import InterExtraBoldTtf from "./assets/fonts/Inter-ExtraBold.ttf";
import InterLightTtf from "./assets/fonts/Inter-Light.ttf";
import InterMediumTtf from "./assets/fonts/Inter-Medium.ttf";
import InterRegularTtf from "./assets/fonts/Inter-Regular.ttf";
import InterSemiBoldTtf from "./assets/fonts/Inter-SemiBold.ttf";
import InterThinTtf from "./assets/fonts/Inter-Thin.ttf";

// Fonts
import FigtreeBoldTtf from "./assets/fonts/Figtree-Bold.ttf";
import FigtreeExtraBoldTtf from "./assets/fonts/Figtree-ExtraBold.ttf";
import FigtreeLightTtf from "./assets/fonts/Figtree-Light.ttf";
import FigtreeMediumTtf from "./assets/fonts/Figtree-Medium.ttf";
import FigtreeRegularTtf from "./assets/fonts/Figtree-Regular.ttf";
import FigtreeSemiBoldTtf from "./assets/fonts/Figtree-SemiBold.ttf";
import FigtreeBlackTtf from "./assets/fonts/Figtree-Black.ttf";

export const FigtreeFonts = [
  {
    fontFamily: "Figtree",
    fontStyle: "normal",
    fontWeight: 300,
    src: `
      url(${FigtreeLightTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Figtree",
    fontStyle: "normal",
    fontWeight: 400,
    src: `
      url(${FigtreeRegularTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Figtree",
    fontStyle: "normal",
    fontWeight: 500,
    src: `
      url(${FigtreeMediumTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Figtree",
    fontStyle: "normal",
    fontWeight: 600,
    src: `
      url(${FigtreeSemiBoldTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Figtree",
    fontStyle: "normal",
    fontWeight: 700,
    src: `
      url(${FigtreeBoldTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Figtree",
    fontStyle: "normal",
    fontWeight: 800,
    src: `
      url(${FigtreeExtraBoldTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Figtree",
    fontStyle: "normal",
    fontWeight: 900,
    src: `
      url(${FigtreeBlackTtf}) format('truetype')
    `,
  },
];

export const interFonts = [
  {
    fontFamily: "Inter",
    fontStyle: "normal",

    // fontDisplay: "swap",
    fontWeight: 900,
    src: `
      url(${InterBlackTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Inter",
    fontStyle: "normal",
    // fontDisplay: "swap",
    fontWeight: 700,
    src: `
      url(${InterBoldTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Inter",
    fontStyle: "normal",
    // fontDisplay: "swap",
    fontWeight: 800,
    src: `
      url(${InterExtraBoldTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Inter",
    fontStyle: "normal",
    // fontDisplay: "swap",
    fontWeight: 300,
    src: `
      url(${InterLightTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Inter",
    fontStyle: "normal",
    // fontDisplay: "swap",
    fontWeight: 500,
    src: `
      url(${InterMediumTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Inter",
    fontStyle: "normal",
    // fontDisplay: "swap",
    fontWeight: 400,
    src: `
      url(${InterRegularTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Inter",
    fontStyle: "normal",
    // fontDisplay: "swap",
    fontWeight: 600,
    src: `
      url(${InterSemiBoldTtf}) format('truetype')
    `,
  },
  {
    fontFamily: "Inter",
    fontStyle: "normal",
    // fontDisplay: "swap",
    fontWeight: 100,
    src: `
      url(${InterThinTtf}) format('truetype')
    `,
  },
];
